import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { PRODUCT_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { StudentProjectListPage } from '@/features/productRequisition/pages/StudentProjectListPage';
import { studentProjectSearchSchema } from '@/features/productRequisition/types/productRequisition.types';

export const Route = createFileRoute('/_auth/product/student-collection-projects/')({
  beforeLoad: () => requirePermission(PRODUCT_PERMISSIONS.STUDENT_PROJECT_VIEW),
  validateSearch: studentProjectSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Mkt Student Collection Project">
      <Suspense fallback={<PageLoader />}>
        <StudentProjectListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
